<template>
  <div>
    <ApplyDetail
      v-if="pageStatus === 'applyDetail'"
      @changeToLeader="changeToLeader()"
    ></ApplyDetail>
    <ApplyLeader
      v-if="pageStatus === 'leader'"
      @changeToDetail="changeToDetail"
    ></ApplyLeader>
  </div>
</template>
<script>
import ApplyDetail from "./applyDetail/ApplyDetail";
import ApplyLeader from "./applyLeader/ApplyLeader";
export default {
  name: "Right",
  components: {
    ApplyDetail,
    ApplyLeader,
  },
  data() {
    return {
      pageStatus: "leader",
    };
  },
  methods: {
    changeToLeader() {
      this.pageStatus = "leader";
    },
    changeToDetail(val) {
      console.log(val)
      this.pageStatus = "applyDetail";
      
    },
  },
};
</script>

<style>
</style>